import {ActionTypeEnum} from "../../../../models";

export const extractTransactionParams = (searchParams: URLSearchParams) => {
    const refundTransParamValue = searchParams.get("bImDq");
    const reSalesTransParamValue = searchParams.get("rUHaU");

    if (refundTransParamValue) {
        return { id: Number(refundTransParamValue), action: ActionTypeEnum.TransactionRefund };
    }
    if (reSalesTransParamValue) {
        return { id: Number(reSalesTransParamValue), action: ActionTypeEnum.IssueSaleTransactionFromSalePrice };
    }

    return null;
};